function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "alerts_svg__c",
  cx: 2.5,
  cy: 2.5,
  r: 2.5
}), React.createElement("path", {
  id: "alerts_svg__a",
  d: "M4 0h10a4 4 0 014 4v10a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4zm0 1.8A2.2 2.2 0 001.8 4v10A2.2 2.2 0 004 16.2h10a2.2 2.2 0 002.2-2.2V4A2.2 2.2 0 0014 1.8H4z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(2 4)"
}, React.createElement("mask", {
  id: "alerts_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#alerts_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#alerts_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#alerts_svg__b)"
}, React.createElement("path", {
  d: "M-2-4h24v24H-2z"
}))), React.createElement("circle", {
  cx: 17,
  cy: 7,
  r: 5,
  fill: "#FFF"
}), React.createElement("g", {
  transform: "translate(15 4)"
}, React.createElement("mask", {
  id: "alerts_svg__d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#alerts_svg__c"
})), React.createElement("use", {
  fill: "#000",
  xlinkHref: "#alerts_svg__c"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#alerts_svg__d)"
}, React.createElement("path", {
  d: "M-15-4H9v24h-24z"
}))));

var SvgAlerts = function SvgAlerts(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/alerts.ec750861.svg";
export { SvgAlerts as ReactComponent };